export default {
  title: "PROCESSSECTION.processSectionTitleCommercial",
  advancedTreatment: "PROCESSSECTION.processAdvancedCoatingCommercial",
  items: [
    {
      image: require("../../images/icon-1.png"),
      text: "PROCESSSECTION.processStep1Commercial",
    },
    {
      image: require("../../images/icon-2.png"),
      text: "PROCESSSECTION.processStep2Commercial",
    },
    {
      image: require("../../images/icon-3.png"),
      text: "PROCESSSECTION.processStep3Commercial",
    },
    {
      image: require("../../images/icon-4.png"),
      text: "PROCESSSECTION.processStep4Commercial",
      subText: "PROCESSSECTION.processStep4SubCommercial",
    },
    {
      image: require("../../images/icon-5.png"),
      text: "PROCESSSECTION.processStep5Commercial",
    },
  ],
};
